import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import Geosuggest from '@ubilabs/react-geosuggest';

const field = (style, placeholder, value, handleInputChange, index) => {
  if (style === 'geosuggest') {
    return (
      <Geosuggest
        initialValue={value}
        inputClassName="form-control"
        placeholder="e.g. Boston"
        types={['(cities)']}
        onChange={(v) => handleInputChange(v, index)}
        onSuggestSelect={(obj) => obj && handleInputChange(obj.label, index)}
      />
    );
  } if (style === 'text_input') {
    return (
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => handleInputChange(e.target.value, index)}
      />
    );
  }

  return (
    <TextareaAutosize
      rows={2}
      value={value}
      onChange={(e) => handleInputChange(e.target.value, index)}
      placeholder={placeholder}
    />
  );
};

function Item({
  value, index, handleInputChange, handleDeleteItem, placeholder, itemHeader, style,
}) {
  return (
    <div className="item">
      {style === 'list' && itemHeader
      && (
      <div className="item-header">
        {itemHeader}
        {' '}
        {index + 1}
      </div>
      )}
      <div className="item-body">
        <div className="flex-grow">
          {field(style, placeholder, value, handleInputChange, index)}
        </div>
        <div className="delete-item">
          <a
            role="button"
            tabIndex={0}
            type="button"
            id="delete-item"
            onClick={() => handleDeleteItem(index)}
          >
            <i className="fa fa-trash-alt" />
          </a>
        </div>
      </div>
    </div>
  );
}

Item.propTypes = {
  value: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleDeleteItem: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  itemHeader: PropTypes.string.isRequired,
  style: PropTypes.string.isRequired,
};

export default Item;
